


























































































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import { MediaResourceModel } from '@/modules/media/models/media-resource.model'
import { isMimeType } from '@/modules/shared/helpers/mime-types'
import format from 'quasar/src/utils/format.js';
import DeleteConfirm from '@/modules/common/dialog/components/shared/DeleteConfirm.vue'
import { MediaDeleteUseCase } from '@/modules/media/use-cases/media-delete.use-case'

@Component
export default class MediaListItem extends Vue {
  constructor(
    private readonly useCase: MediaDeleteUseCase
  ) {
    super()
  }

  @Prop({ required: true }) file: File | MediaResourceModel
  @Prop({ default: false }) loading: boolean
  @Prop({ default: true }) deletable: boolean
  @Prop() error: string

  protected readonly imageTypes = ['jpg', 'png', 'bmp', 'gif']

  protected get isImage() {
    return this.imageTypes.some(type => isMimeType(this.file.type || this.file.mime_type, type))
  }

  protected get fileSrc() {
    return this.file.url || URL.createObjectURL(this.file)
  }

  protected get fileFullName() {
    return this.file.full_name || this.file.name
  }

  protected get fileName() {
    if (this.file.full_name) {
      return this.file.name
    }
    const name = this.file.name
    return name.slice(0, name.lastIndexOf('.'))
  }

  protected get fileExtension() {
    const name = this.file.full_name || this.file.name
    return name.slice(name.lastIndexOf('.'))
  }

  protected get fileSize() {
    return format.humanStorageSize(this.file.size)
  }

  protected get isLoading() {
    return this.loading || this.useCase.isLoading
  }

  protected get errorMessage() {
    return this.error || this.useCase.getErrorMessage
  }

  protected remove() {
    if (this.deletable) {
      this.$q.dialog({
        component: DeleteConfirm,
        title: 'حذف یک فایل',
        message: 'آیا از حذف این فایل اطمینان دارید ؟'
      }).onOk(() => {
        if (this.file.id) {
          this.useCase.execute(this.file.id)
            .then(() => {
              this.$emit('remove')
            })
        } else {
          this.$emit('remove')
        }
      })
    }
  }
}
